import bangkok01 from '../assets/bangkok-01.png';
import bangkok02 from '../assets/bangkok-02.png';
import bangkok03 from '../assets/bangkok-03.png';
import bangkok04 from '../assets/bangkok-04.png';
import bangkok05 from '../assets/bangkok-05.png';
import bangkok06 from '../assets/bangkok-06.png';

export const NOTES = [
  {
    slug: 'most-people-dont-want-freedom',
    title: "Most people don't want freedom.",
    categories: ['Freedom', 'Work'],
    excerpt:
      'Freedom at twenty-five looked like fewer rules. Freedom at forty looks like fewer regrets. The word stays the same. The invoice changes.',
    content: [
      'They want certainty with optional freedom. Which is different. Freedom sounds great until it removes the structure that was quietly making half your decisions for you. Then it starts looking suspiciously like a calendar with no instructions.',
      'Most people say they want freedom the way people say they want to travel more. It sounds virtuous. It signals depth. It also assumes freedom will cooperate once it arrives.',
      'Real freedom is less cinematic. It is a Tuesday with no one telling you what matters. That sounds peaceful until you realize you might be the unreliable narrator of your own life.',
    ],
    image: bangkok01,
    imageAlt: 'Bangkok street at dusk',
  },
  {
    slug: 'living-abroad-personality',
    title: "Most people don't want freedom.",
    categories: ['Travel', 'Escape'],
    excerpt:
    'Freedom at twenty-five looked like fewer rules. Freedom at forty looks like fewer regrets. The word stays the same. The invoice changes.',
    content: [
      'It mostly removes the excuses. Different city, different weather, different food, same brain following you around like unpaid luggage. Bangkok can give you a new setting. It cannot do the inner admin work, which feels inconsiderate but fair.',
      'Moving countries is often sold as reinvention. In practice it is more like changing the wallpaper in a house you still have to live in. The view improves. The plumbing issues remain yours.',
      'That is not an argument against going. It is an argument against expecting geography to do therapy.',
    ],
    image: bangkok02,
    imageAlt: 'Bangkok alley market',
  },
  {
    slug: 'ladder-wrong-wall',
    title: "Most people don't want freedom.",
    categories: ['Work', 'Money'],
    excerpt:
      'Freedom at twenty-five looked like fewer rules. Freedom at forty looks like fewer regrets. The word stays the same. The invoice changes.',
    content: [
      'A deeply annoying thing to realize after climbing for a while. Modern work is very good at giving people goals, titles, dashboards, and performance reviews. It is less good at answering whether any of it is building a life you actually want.',
      'The ladder metaphor is unfair because it implies you were careless. Often you were diligent. You hit milestones. You collected proof. Then one quiet afternoon you notice the view from the top is not the view you wanted.',
      'The hard part is not stopping. The hard part is admitting you were competent at the wrong assignment.',
    ],
    image: bangkok03,
    imageAlt: 'Bangkok skyline',
  },
  {
    slug: 'move-away-from-feeling',
    title: "Most people don't want freedom.",
    categories: ['Relationships', 'Escape'],
    excerpt:
      'Freedom at twenty-five looked like fewer rules. Freedom at forty looks like fewer regrets. The word stays the same. The invoice changes.',
    content: [
      'The destination gets all the branding. The beach. The skyline. The cheaper rent. But the real story is usually quieter: exhaustion, loneliness, boredom, status fatigue, or the suspicion that staying would turn you into someone you did not particularly like.',
      'Places are convenient narrators. They let you say you moved for opportunity instead of admitting you moved because your nervous system filed a complaint.',
      'Sometimes the move works. Sometimes you discover you packed the feeling in your carry-on.',
    ],
    image: bangkok04,
    imageAlt: 'Bangkok street scene',
  },
  {
    slug: 'internet-connection-audience',
    title: "Most people don't want freedom.",
    categories: ['Work', 'Relationships'],
    excerpt:
      'Freedom at twenty-five looked like fewer rules. Freedom at forty looks like fewer regrets. The word stays the same. The invoice changes.',
    content: [
      'Which is a neat trick. Everyone gets a platform, everyone gets a take, everyone gets metrics, and somehow the group chat still feels more human than the product built by a billionaire who claims to be improving civilization.',
      'Audience is not intimacy. Metrics are not friendship. Virality is not belonging. We know this. We still refresh anyway.',
      'The useful question is not whether to log off. It is whether the life you are building offline can compete with the cheap dopamine of being watched.',
    ],
    image: bangkok05,
    imageAlt: 'Bangkok canal',
  },
  {
    slug: 'freedom-moving-target',
    title: "Why 'freedom' is a moving target.",
    categories: ['Money', 'Freedom'],
    excerpt:
      'Freedom at twenty-five looked like fewer rules. Freedom at forty looks like fewer regrets. The word stays the same. The invoice changes.',
    content: [
      'Freedom at twenty-five looked like fewer rules. Freedom at forty looks like fewer regrets. The word stays the same. The invoice changes.',
      'We treat freedom like a destination, then act surprised when arriving does not feel like relief. Maybe freedom is less a place and more a maintenance schedule.',
      'Surviving is paying the bill. Thriving is deciding what the bill was for.',
    ],
    image: bangkok06,
    imageAlt: 'Bangkok traffic',
  },
];

export function getNoteBySlug(slug) {
  return NOTES.find((note) => note.slug === slug);
}
